import { expectEl } from "../../util";
import { playVideo } from "./playPauseVideo";

export function skipVideo() {
    playVideo();

    const skipBtnEl = expectEl("#game .skipBtn");

    const activeVideo = document.querySelector<HTMLVideoElement>(
        '#game .video.active[data-video-type="video"]',
    );
    if (!activeVideo || activeVideo.paused) {
        skipBtnEl.classList.add("--hidden");
        return;
    }

    skipBtnEl.classList.remove("--hidden");
    activeVideo.currentTime = activeVideo.duration;
}
